
(function languageModuleDefinition() {

    'use strict';

    angular.module('Language', ['pascalprecht.translate', 'Config', 'tmh.dynamicLocale']);

})();